/* generated from Designfiles Public by generate_data_designfles */
require ('./richcontent.css');
